export function getMinMax(arr) {
  // 判断传入的集合是否为空或不是数组
  if (!Array.isArray(arr) || arr.length === 0) {
    return { max: 300, min: 0 };
  }

  // 使用扩展运算符(...)获取最大值和最小值
  const max = Math.max(...arr);
  const min = Math.min(...arr);

  return { max, min };
}
export function getLineInterval(arr) {
  // 判断传入的集合是否为空或不是数组
  const min = arr.min
  const max = arr.max
  const interval = Math.floor((max - min)/5)
  return interval > 5 ? interval : 5
}

/**
 * 格式化省级行政区名称
 * @param {string} name - 传入的省市区名称
 * @returns {string} 格式化后的名称
 */
export function formatCityName(name) {
  // 1. 安全拦截：如果传入的不是有效字符串（如 null, undefined），直接返回原值
  if (!name || typeof name !== 'string') {
    return name;
  }

  // 2. 精确匹配逻辑：处理四大直辖市
  const cityMap = {
    '北京': '北京市',
    '天津': '天津市',
    '重庆': '重庆市',
    '上海': '上海市'
  };

  // 如果在字典中找到了，直接返回对应的值
  if (cityMap[name]) {
    return cityMap[name];
  }

  // 3. 模糊匹配逻辑：处理自治区（只要包含关键字即可）
  if (name.includes('新疆')) {
    return '新疆维吾尔自治区';
  }
  if (name.includes('西藏')) {
    return '西藏自治区';
  }
  if (name.includes('内蒙古')) {
    return '内蒙古自治区';
  }
  if (name.includes('广西')) {
    return '广西壮族自治区';
  }
  if (name.includes('宁夏')) {
    return '宁夏回族自治区';
  }
  if (name.includes('香港')) {
    return '香港特别行政区';
  }
  if (name.includes('澳门')) {
    return '澳门特别行政区';
  }
  if (name.includes('台湾')) {
    return '台湾省';
  }

  // 4. 其他省份：原样返回入参值
  return name;
}


